import { MainWebShop } from '@as-react/common-types';
import { BoyFillIcon, FemaleFillIcon, GirlFillIcon, JuniorFillIcon, MaleFillIcon, UnisexFillIcon, } from '@yonderland/andes-icons';
export const getIcon = (id) => {
    switch (String(id)) {
        case 'dms':
        case '2669':
            return FemaleFillIcon;
        case 'girl':
        case '2617':
            return GirlFillIcon;
        case 'hrn':
        case '2668':
            return MaleFillIcon;
        case 'boy':
        case '2616':
            return BoyFillIcon;
        case 'uni':
        case '2670':
            return UnisexFillIcon;
        case 'uni_jr':
        case '2618':
            return JuniorFillIcon;
        default:
            return null;
    }
};
const tagColorMapping = {
    [MainWebShop.JUTTU]: new Map([
        [1, 'primary'],
        [2, 'neutral'],
        [3, 'active'],
        [4, 'sale'],
        [5, 'sustainability'],
        [6, 'promotion'],
        [7, 'dark'],
    ]),
    [MainWebShop.COTSWOLD]: new Map([
        [1, 'active'],
        [2, 'sustainability'],
        [3, 'sale'],
        [4, 'sustainability'],
        [5, 'dark'],
        [6, 'promotion'],
        [7, 'neutral'],
    ]),
    [MainWebShop.RUNNERSNEED]: new Map([
        [1, 'active'],
        [2, 'dark'],
        [3, 'promotion'],
        [4, 'sale'],
        [5, 'neutral'],
        [6, 'sustainability'],
        [7, 'dark'],
    ]),
    [MainWebShop.BEVER]: new Map([
        [1, 'primary'],
        [2, 'neutral'],
        [3, 'promotion'],
        [4, 'primary'],
        [5, 'dark'],
        [6, 'sale'],
        [7, 'sustainability'],
    ]),
    [MainWebShop.SNOWANDROCK]: new Map([
        [1, 'active'],
        [2, 'sale'],
        [3, 'promotion'],
        [4, 'neutral'],
        [5, 'sustainability'],
        [6, 'dark'],
        [7, 'primary'],
    ]),
    [MainWebShop.ASADVENTURE]: new Map([
        [1, 'primary'],
        [2, 'active'],
        [3, 'active'],
        [4, 'sale'],
        [5, 'promotion'],
        [6, 'sustainability'],
        [7, 'dark'],
    ]),
    [MainWebShop.AYACUCHO]: new Map([
        [1, 'primary'],
        [2, 'active'],
        [3, 'active'],
        [4, 'sale'],
        [5, 'promotion'],
        [6, 'sustainability'],
        [7, 'dark'],
    ]),
};
const FALLBACK_TAG_COLOR = 2;
export const getProductPriceOverlayTagColorAndContent = (mainWebShop, priceOverlay) => ({
    overlayTagColor: tagColorMapping[mainWebShop].get((priceOverlay === null || priceOverlay === void 0 ? void 0 : priceOverlay.idOverlayBackground) || FALLBACK_TAG_COLOR),
    overlayTagContent: (priceOverlay === null || priceOverlay === void 0 ? void 0 : priceOverlay.overlayBackgroundCodeDescription) || (priceOverlay === null || priceOverlay === void 0 ? void 0 : priceOverlay.overlayCode),
});
export const getNewProductOverlayTagColorAndTranslationKey = (mainWebShop) => {
    let tagColor;
    let translationKey;
    switch (mainWebShop) {
        case MainWebShop.JUTTU:
            tagColor = 'primary';
            translationKey = 'product.new.label.2';
            break;
        case MainWebShop.COTSWOLD:
            tagColor = 'sale';
            translationKey = 'product.new.label.3';
            break;
        case MainWebShop.RUNNERSNEED:
            tagColor = 'promotion';
            translationKey = 'product.new.label.1';
            break;
        case MainWebShop.BEVER:
            tagColor = 'primary';
            translationKey = 'product.new.label.1';
            break;
        case MainWebShop.SNOWANDROCK:
            tagColor = 'sale';
            translationKey = 'product.new.label.1';
            break;
        default:
            tagColor = 'active';
            translationKey = 'product.new.label.1';
            break;
    }
    return {
        tagColor,
        translationKey,
    };
};
